import Logo from "../../assets/img/logo.png";
import { IReviewProps } from "../types/review";

export const Information = {
  AdminName: "Chinwe Ukaonu MD.",
  AppDescription: "Ufamilymedicine is a platform for primary care.",
  AppName: "Ufamilymedicine",
};
export { Logo };

export const Colors = {
  BluePrimary: "var(--blue-primary)",
};

export const HttpCodes = {
  Unauthorized: 401,
  Forbidden: 403,
  NotFound: 404,
  InternalServerError: 500,
  BadRequest: 400,
  UnprocessableEntity: 422,
  Success: 200,
  Created: 201,
};
